<template>
    <stepper-layout
        :stepTitle="'Payment Review'"
        :stepIcon="'receipt'"
        :class="darkMode ? '' : 'pl-1 pt-1'"
    >
        <payment-info
            :currentStep="currentStep"
            :payload="payload"
            :ccInfo="ccInfo"
            :cart="cart"
            :convenienceFees="convenienceFees"
            @unitSelect="unitSelect"
            @paymentOptions="paymentOptions"
        />
        <v-layout>
            <v-btn
                data-testid="payment-review-return-unit-select-btn"
                class="payment-review-return-unit-select-btn my-3 mr-4"
                @click="unitSelect"
            >
                <v-icon class="mr-2">navigate_before</v-icon>
                Return to Unit Select
            </v-btn>
            <v-btn
                data-testid="payment-review-return-payment-options-btn"
                class="payment-review-return-payment-options-btn mt-3 mb-5"
                @click="paymentOptions"
            >
                <v-icon class="mr-2">navigate_before</v-icon>
                Return to Payment Options
            </v-btn>
        </v-layout>
        <v-layout column class="subheading mb-3 mx-4">Please review all details of
            this transaction. If needed, you may navigate to a previous step with one of
            the above buttons. If everything looks correct, click "Submit" to process
            payment.
        </v-layout>
    </stepper-layout>
</template>

<script>
import PaymentInfo from "../partials/PaymentInfo";
import StepperLayout from "@/layouts/StepperLayout";
import { mapState } from "vuex";

export default {
  props: {
    currentStep: {
      type: Number
    },
    payload: {
      type: Object
    },
    ccInfo: {
      type: Object
    },
    cart: {
      type: Array
    },
    convenienceFees: {
      type: [String, Object, Array]
    }
  },
  methods: {
    unitSelect() {
      this.$emit("unitSelect");
    },
    paymentOptions() {
      this.$emit("paymentOptions");
    }
  },
  computed: {
    ...mapState({
      darkMode: state => state.application.settings.darkTheme
    })
  },
  components: { PaymentInfo, StepperLayout }
};
</script>

<style scoped>

</style>
